<app-pagetitle title="Proposta Comercial" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-xl-12">
        <div class="card">
            <div class="card-body">

                <form [formGroup]="propostraForm" (ngSubmit)="onSubmit()">

                    <div class="row">
                        <div class="mb-3 col-sm-12 col-lg-4">
                            <label class="form-label">Descrição</label> <span style="color: red;">*</span>
                            <input class="form-control" placeholder="Digite uma descrição" type="text"
                                formControlName="descricao" 
                                [ngClass]="{
                                    'is-invalid':
                                    propostraForm.controls.descricao.errors &&
                                    propostraForm.get('descricao')?.touched,
                                  }" />
                            <div class="invalid-feedback"
                                *ngIf="propostraForm.get('descricao')?.touched && propostraForm.get('descricao')?.invalid">
                                Informe uma descrição.
                            </div>
                        </div>

                        <div class="mb-3 col-sm-12 col-lg-3">
                            <label class="form-label">Configuração</label>
                            <input class="form-control" placeholder="Digite uma configuração" type="text"
                                formControlName="configuracao" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="mb-3 col-sm-12 col-lg-7">
                            <label class="form-label">Observação</label>
                            <textarea class="form-control" placeholder="Digite uma observação" type="text"
                                formControlName="observacao"></textarea>
                        </div>
                    </div>

                    <div class="col-12">
                        <button (click)="voltar()" type="button" class="btn btn-soft-link waves-effect">Voltar</button>

                        @if(isLoading){
                            <button type="button" class="btn btn-sm btn-primary waves-effect waves-light">
                                <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> Trabalhando
                            </button>
                        }@else {
                            <button type="submit" class="btn btn-success btn-sm waves-effect waves-light"> Salvar </button>
                        }
                    </div>
                </form>

            </div><!-- end card-body -->
        </div><!-- end card -->
    </div><!-- end col -->